<template>
  <div id="login">
    <!-- <span class="bg"></span> -->

    <v-app-bar app color="primary">
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text"></v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-btn icon @click="exitApp">
        <v-icon color="white darken-2">mdi-close-circle</v-icon>
      </v-btn>
    </v-app-bar>
    <v-container fluid style="margin-top: 50px;">
      <div align="center" style="margin-top: 0px;">
        <v-img src="../../assets/logo.png" width="325px" height="125px"></v-img>
      </div>

      <v-row align="center" justify="center" class="mt-2">
        <v-col cols="10" sm="8" md="4">
          <v-form @submit.prevent="onSubmit" autocomplete="off">
            <v-text-field
              label="Email"
              prepend-icon="mdi-account"
              type="email"
              rounded
              outlined
              v-model="loginObj.email"
              :error-messages="emailErrors"
              @input="$v.loginObj.email.$touch()"
              @blur="$v.loginObj.email.$touch()"
            />

            <v-text-field
              id="password"
              label="Password"
              prepend-icon="mdi-lock"
              type="password"
              rounded
              outlined
              v-model="loginObj.password"
              :error-messages="passwordErrors"
              @input="$v.loginObj.password.$touch()"
              @blur="$v.loginObj.password.$touch()"
            />

            <div class="text-center mt-7">
              <v-btn
                color="primary"
                class="ma-2"
                type="submit"
                dark
                rounded
                :loading="buttonLoadingLogin"
                >Iniciar Sesión</v-btn
              >
              <br />
              <v-btn
                color="primary"
                small
                dark
                rounded
                to="/register"
                class="ma-2"
                >Regístrarse</v-btn
              >
            </div>
          </v-form>
        </v-col>
      </v-row>
    </v-container>

    <Alert ref="Alert"></Alert>
  </div>
</template>
<script>
import Alert from "@/components/Reusable/Alert.vue";
import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
  email,
  requiredIf,
} from "vuelidate/lib/validators";

export default {
  name: "Login",
  components: {
    Alert,
  },
  mixins: [validationMixin],
  data() {
    return {
      butonDisabledLogin: false,
      buttonLoadingLogin: false,
      modelRecoveryPasswordModal: false,
      emailRecover: "",

      buttonLoadingRecovery: false,
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,

      loginObj: {
        email: "",
        password: "",
      },
    };
  },
  validations: {
    loginObj: {
      email: { required, email },
      password: { required },
    },
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.loginObj.email.$dirty) return errors;
      !this.$v.loginObj.email.email &&
        errors.push("Debe ser válido el correo electrónico");
      !this.$v.loginObj.email.required && errors.push("Correo es requerido");
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.loginObj.password.$dirty) return errors;
      !this.$v.loginObj.password.required &&
        errors.push("Contraseña es requerida");
      return errors;
    },
  },
  methods: {
    exitApp() {
      this.$router.push("/");
    },
    ShowRecoveryPasswordModal() {
      this.modelRecoveryPasswordModal = true;
    },
    onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.$store.commit("showSnackbar", {
          text: "campos invalidos en el formulario",
          color: "info",
        });
      } else {
        this.buttonLoadingLogin = true;
        const formData = {
          email: this.loginObj.email,
          password: this.loginObj.password,
        };
        this.$store
          .dispatch("login", formData)
          .then((response) => {
            this.buttonLoadingLogin = false;
            this.$store.commit("showSnackbar", {
              text: "Inicio de sesión con exito",
              color: "success",
            });
            this.$router.push("/");
          })
          .catch((error) => {
            this.buttonLoadingLogin = false;
            this.$refs.Alert.open(
              "Información",
              "Email o contraseña invalidos",
              { color: "primary" }
            );
          });
      }
    },
  },
  mounted() {},
};
</script>
